import type { AuthTokens } from '@/api/apiTypes';

const ACCESS_TOKEN_KEY = 'admin_portal.access_token';
const REFRESH_TOKEN_KEY = 'admin_portal.refresh_token';
const AUTH_CHANGE_EVENT = 'admin-portal:auth-change';

function dispatchAuthChange() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_CHANGE_EVENT));
  }
}

function readStorageValue(key: string) {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem(key);
}

export function getAccessToken() {
  return readStorageValue(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return readStorageValue(REFRESH_TOKEN_KEY);
}

export function getAuthTokens(): AuthTokens | null {
  const access = getAccessToken();
  const refresh = getRefreshToken();

  if (!access || !refresh) {
    return null;
  }

  return { access, refresh };
}

export function setAuthTokens(tokens: AuthTokens) {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(ACCESS_TOKEN_KEY, tokens.access);
  window.localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh);
  dispatchAuthChange();
}

export function clearAuthTokens() {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(ACCESS_TOKEN_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN_KEY);
  dispatchAuthChange();
}

export function subscribeToAuthChanges(listener: () => void) {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  window.addEventListener(AUTH_CHANGE_EVENT, listener);

  return () => {
    window.removeEventListener(AUTH_CHANGE_EVENT, listener);
  };
}